// The key lives in this tab only: closing it forgets the key, like the generator page did.
// Storage can be unavailable (private mode, blocked site data); every access is guarded so
// the console still works with the key held in memory for the session.
const STORAGE_KEY = 'limited-link-key';

export function readAgentKey(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function storeAgentKey(key: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, key);
  } catch {
    // Kept in memory by the provider; nothing else to do.
  }
}

export function clearAgentKey(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing stored, nothing to clear.
  }
}
